import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AssignExpertLevelRequest } from "@shopexperts/legacy-api";

interface AssignAdminExpertLevelInput {
  expertId: number;
  organizationId?: number | null;
  body: AssignExpertLevelRequest;
}

export function useAssignAdminExpertLevel() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "expert-levels", "assign"],
    mutationFn: async ({ expertId, body }: AssignAdminExpertLevelInput) => {
      return await api.admin.expertLevels.assignToExpert({
        params: { expert: expertId },
        body,
      });
    },
    onSuccess: (_assignment, variables) => {
      toaster.create({ title: "Expert level assigned successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-levels"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-levels", "history", variables.expertId] });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert", variables.expertId] });
      queryClient.invalidateQueries({ queryKey: ["admin", "experts", variables.expertId] });

      if (variables.organizationId) {
        queryClient.invalidateQueries({ queryKey: ["admin", "wallet", "organization", variables.organizationId, "level"] });
      }
    },
    onError: (error: Error) => {
      toaster.create({ title: `Failed to assign expert level: ${error.message}`, type: "error" });
    },
  });
}
